export const ENDPOINTS = {
  GET_CATEGORIES: "/o/headless-admin-taxonomy/v1.0/taxonomy-vocabularies/",
  GET_WEB_CONTENT:
    "/o/headless-delivery/v1.0/content-structures/{structureId}/structured-contents",
  OAUTH_TOKEN: "/o/oauth2/token",
  TAXONOMY_CATEGORIES: "/taxonomy-categories",
};
